import React, { FunctionComponent } from 'react';

import { ColumnHeaderProps } from 'directory/listings/notification-modals/types';

import 'directory/listings/notification-modals/components/ColumnHeader/ColumnHeader.scss';

export const ColumnHeader: FunctionComponent<ColumnHeaderProps> = ({
    icon,
    iconColor,
    title,
    subtitle,
    subtitleIcon,
}) => {
    return (
        <div className="column-header d-flex align-items-center">
            {icon && (
                <div className="column-header__icon-wrapper mr-2">
                    <div className="column-header__icon" style={{ color: iconColor }}>
                        {icon}
                    </div>
                </div>
            )}
            <div className="column-header__content">
                <div className="column-header__title">{title}</div>
                {subtitle && (
                    <div className="column-header__subtitle text-muted small">
                        {subtitleIcon && <i className={`${subtitleIcon} mr-2`} />}
                        {subtitle}
                    </div>
                )}
            </div>
        </div>
    );
};
